const PaymentsListMode = {
  BACKOFFICE: 'BACKOFFICE',
  PAYOR: 'PAYOR',
  PAYEE: 'PAYEE',
};

export { PaymentsListMode };
